// extracted by mini-css-extract-plugin
module.exports = {"icon":"depositLinkCopy_icon__1KJWu"};